import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { getSeparatorsForLanguage, splitAmountString } from "utils/formatters";

const formatFractionalAndThousand = (numberAmount, languageString) => {
  const { thousandSeparator, fractionalSeparator, millionSeparator } =
    getSeparatorsForLanguage(languageString);

  const numberString = numberAmount.toString();

  const { length } = numberString;

  if (length === 3) {
    // только копейки '0,30
    const fractionalPart = numberString.slice(-2);
    const integerPart = numberString.slice(0, 1);
    return `${integerPart}${fractionalSeparator}${fractionalPart}`;
  }

  if (length >= 4 && length <= 5) {
    // от '10 00' до '100 00'
    const fractionalPart = numberString.slice(-2);
    const mainPart = numberString.slice(-5, -2);

    return `${mainPart}${fractionalSeparator}${fractionalPart}`;
  }

  if (length >= 6 && length <= 8) {
    // от '1 000 00' до '100 000 00'
    const fractionalPart = numberString.slice(-2);
    const mainPart = numberString.slice(-5, -2);
    const thousandPart = numberString.slice(-8, -5);

    return `${thousandPart}${thousandSeparator}${mainPart}${fractionalSeparator}${fractionalPart}`;
  }

  if (length === 9) {
    // '1 000 000 00'
    const fractionalPart = numberString.slice(-2);
    const mainPart = numberString.slice(-5, -2);
    const thousandPart = numberString.slice(-8, -5);
    const millionPart = numberString.slice(0, 1);

    return `${millionPart}${millionSeparator}${thousandPart}${thousandSeparator}${mainPart}${fractionalSeparator}${fractionalPart}`;
  }

  if (length === 10) {
    // '10 000 000 00'
    const fractionalPart = numberString.slice(-2);
    const mainPart = numberString.slice(-5, -2);
    const thousandPart = numberString.slice(-8, -5);
    const millionPart = numberString.slice(0, 2);

    return `${millionPart}${millionSeparator}${thousandPart}${thousandSeparator}${mainPart}${fractionalSeparator}${fractionalPart}`;
  }

  return "0";
};

const useFormatBonusBalance = () => {
  return (number: number) => {
    if (!number && number !== 0) {
      return "0";
    }

    const userLanguage = localStorage.getItem(STORAGE_LANGUAGE_NAME) || "EN";

    const formattedWithCorrectSeparatorsRow = formatFractionalAndThousand(
      number,
      userLanguage,
    );

    return splitAmountString(
      formattedWithCorrectSeparatorsRow,
      getSeparatorsForLanguage(userLanguage).fractionalSeparator,
    );
  };
};

export default useFormatBonusBalance;
